import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { IoClose } from 'react-icons/io5';
import { FaShoppingBag } from 'react-icons/fa';

function MobileMenu({ isOpen, onClose }) {
  const location = useLocation();

  const menuItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About The Club' },
    { path: '/competitive', label: 'Competitive Swimming' },
    { path: '/resources', label: 'Resources' },
    { path: '/programs', label: 'Programs' },
    { path: '/committee', label: 'Committee' },
    { path: '/events', label: 'Events' },
    { path: '/results', label: 'Results' },
    { path: '/new-pool', label: 'New Pool' },
    { path: '/masters-interest', label: 'Masters/Adults' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={onClose}
          />

          {/* Mobile Menu Panel */}
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
            className="fixed top-0 right-0 bottom-0 w-80 max-w-full bg-navy-900 z-50 overflow-y-auto shadow-2xl lg:hidden"
          >
            {/* Close Button */}
            <div className="flex justify-end p-4">
              <button
                onClick={onClose}
                className="text-white hover:text-primary-300 transition-colors p-2"
                aria-label="Close menu"
              >
                <IoClose size={32} />
              </button>
            </div>

            {/* Menu Items */}
            <nav className="px-6 py-4">
              <ul className="space-y-2">
                {menuItems.map((item, index) => (
                  <motion.li
                    key={item.path}
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.05 }}
                  >
                    <Link
                      to={item.path}
                      onClick={onClose}
                      className={`block px-4 py-3 rounded-lg text-white font-medium transition-all duration-200 ${
                        location.pathname === item.path
                          ? 'bg-white/10 text-primary-300'
                          : 'hover:bg-white/5'
                      }`}
                    >
                      {item.label}
                    </Link>
                  </motion.li>
                ))}
              </ul>

              {/* Shop Button */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
                className="mt-6"
              >
                <a
                  href="https://pbteamwear.co.uk/collections/marple-sc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 w-full text-center bg-primary-600 text-white py-3 px-4 rounded-full font-semibold hover:bg-primary-700 transition-all duration-300"
                >
                  <FaShoppingBag className="w-4 h-4" />
                  Shop
                </a>
              </motion.div>
            </nav>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}

export default MobileMenu;
